import { Button } from "@/components/ui/button";
import { MapPinOff, RotateCw, X } from "lucide-react";

const REASONS = {
  denied: ["Tu navegador bloqueó el acceso a tu ubicación.", "Toca el ícono a la izquierda de la dirección del sitio, permite «Ubicación» y luego Reintentar."],
  unavailable: ["Tu equipo no pudo determinar dónde estás.", "Revisa que la ubicación esté activada en la configuración de tu equipo o conéctate a una red Wi-Fi."],
  timeout: ["La detección de tu ubicación tardó demasiado.", "Suele pasar en computadores sin Wi-Fi. Puedes reintentar o elegir tu región y comuna."],
  outside: ["Tu ubicación parece estar fuera de Chile.", "Elige la región y comuna donde quieres buscar talleres."],
  service: ["No pudimos identificar tu comuna en este momento.", "Inténtalo de nuevo en unos segundos o elige tu región y comuna."],
  unsupported: ["Tu navegador no permite detectar la ubicación.", "Elige tu región y comuna para ver los talleres cerca de ti."],
};

export function LocationNotice({ reason, onRetry, onDismiss }) {
  const r = REASONS[reason];
  if (!r) return null;
  const retry = !["outside", "unsupported"].includes(reason);
  return (
    <div role="status" className="mb-4 flex items-start gap-3 rounded-xl border border-amber-300/70 bg-amber-50 dark:bg-amber-950/30 px-4 py-3 animate-in fade-in slide-in-from-top-1 duration-300" data-testid="location-notice">
      <MapPinOff className="w-5 h-5 shrink-0 mt-0.5 text-amber-600" />
      <div className="flex-1 min-w-0 text-sm sm:flex sm:items-center sm:gap-3">
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-foreground" data-testid="location-notice-title">{r[0]}</p>
          <p className="text-muted-foreground">{r[1]}</p>
        </div>
        {retry && (
          <Button size="sm" variant="outline" onClick={onRetry} className="mt-2 sm:mt-0 shrink-0 rounded-full border-amber-400 bg-background" data-testid="location-notice-retry">
            <RotateCw className="w-3.5 h-3.5 mr-1.5" />Reintentar
          </Button>
        )}
      </div>
      <button type="button" onClick={onDismiss} aria-label="Cerrar aviso" className="shrink-0 grid place-items-center w-7 h-7 rounded-full text-muted-foreground hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-colors" data-testid="location-notice-close">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
